import React from 'react';

import { iiafe } from '../../../../../utils/async';
import { Icon } from '../../../icon/icon';

type Props = {
  onClick: () => Promise<void>;
  title?: string;
  loading?: boolean;
  disabled?: boolean;
};

const DownloadIcon = ({ loading = false, ...props }: Props) => {
  return (
    <Icon
      disabled={props.disabled || loading}
      fixedWidth={true}
      icon={['fal', loading ? 'spinner' : 'cloud-arrow-down']}
      mouseDownStyle={{ opacity: 0.5 }}
      spin={loading}
      stopPropagationOnClick={true}
      title={props.title}
      onClick={() => iiafe(props.onClick)}
      onHoverStyle={{ icon: ['fad', loading ? 'spinner' : 'cloud-arrow-down'] }}
    />
  );
};

export { DownloadIcon };
